import { useEffect, useRef } from 'react'

import { Location, useCantBookOnline, useLocations } from '@/features/location'
import { useAppConfigStore } from '@/stores/app-store-config/appConfigStore'
import { useCartStore } from '@/stores/cart-store/cartStore'
import { useStepStore } from '@/stores/step-store/stepStore'

const getLocationFromQuery = (hotelCode: string, locations?: Location[]) =>
	locations?.find((loc) => loc.hotelCode === hotelCode)

export const useLocationQuery = () => {
	const urlQuery = useAppConfigStore.use.urlQuery()
	const setUrlQuery = useAppConfigStore.use.setUrlQuery()
	const setLocation = useCartStore.use.setLocation()
	const setNextStep = useStepStore.use.setNextStep()

	const { cantBeBooked } = useCantBookOnline()

	const hasRun = useRef(false)

	const { data: locations } = useLocations()

	useEffect(() => {
		if (hasRun.current) return
		if (!urlQuery) return

		const { hotelCode, ...restQuery } = urlQuery
		if (!hotelCode || !locations) return

		if (cantBeBooked(hotelCode)) {
			hasRun.current = true
			return
		}

		const locationFromQuery = getLocationFromQuery(hotelCode, locations)

		if (!locationFromQuery) {
			hasRun.current = true
			return
		}

		setLocation(locationFromQuery)
		setNextStep()
		hasRun.current = true

		setUrlQuery(restQuery)
	}, [cantBeBooked, locations, setLocation, setNextStep, setUrlQuery, urlQuery])
}
